import { render, staticRenderFns } from "./LawMatterBudgetReportArchivedExpensesList.vue?vue&type=template&id=2066cf2d&"
import script from "./LawMatterBudgetReportArchivedExpensesList.vue?vue&type=script&lang=js&"
export * from "./LawMatterBudgetReportArchivedExpensesList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterBudgetReportArchivedExpensesList.vue?vue&type=style&index=0&id=2066cf2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports